/**
 * @file ConsoleTokenCtl.js
 * @module ConsoleTokenCtl
 * @description 共通コンソールトークンの受信と検証を行うモジュール
 */

import { jwtDecode } from 'jwt-decode';
import { toast } from 'react-toastify';
import { SC_STATE , C_URLS , C_LOGWORDING , C_ERRWORDING } from './Constants';

/**
 * トークンの有効性を検証し、同期で結果を返す関数
 * @function
 * @param {string} token - 検証対象のJWTトークン
 * @returns {string} 正常な場合はトークン文字列を返す
 * @throws {Error} 検証エラー時は例外をスロー
 */
export const validateToken = (token) => {
  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    if (decodedToken.exp < currentTime) {
      toast.error('Token has expired');
      throw new Error('【デバッグ用】フロントエンドが共通PFトークン期限切れを検知しました');
    }
    return token;
  } catch (e) {
    toast.error('Token decode error');
    throw new Error('トークンのデコードに失敗しました');
  }
};

/**
 * 共通コンソールトークンを取得し、検証する関数
 * @function
 * @param {function} [setLoadingState] - ローディング状態を更新するコールバック関数（省略可）
 * @returns {string} 正常な場合はトークン文字列を返す。エラー時は例外をスロー。
 */
export const GetConsoleToken = (setLoadingState) => {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('idToken');

  if (!token) {
    setLoadingState?.(SC_STATE.ERR_NONPERMANENT);
    throw new Error('認可情報が取得できませんでした');
  }
  return validateToken(token);
};

/**
 * postMessageリスナーを登録する関数
 * @function
 * @param {function} callback - トークン受信時に呼ばれるコールバック（引数は検証済みトークン）
 */
export const registerConsoleTokenListener = (callback) => {
  const listener = (event) => {
    if (event.data.type === 'postIdToken' && event.data.idToken) {
      try {
        const token = validateToken(event.data.idToken);
        //console.warn('[ConsoleTokenPostMsgListener]', token);
        callback(token);
      } catch (e) {
        throw new Error('トークンの検証に失敗しました: ' + e.message);
      }
    }
  };
  window.addEventListener('message', listener);

  // クリーンアップ用にリスナー解除関数を返す
  return () => window.removeEventListener('message', listener);
};
